// import ReactDOM from "react-dom"
import styled from '@emotion/styled'
import React, { useEffect } from 'react'

import Box, { BoxProps } from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import { Portal } from '@/modules/components/Portal'

const ModalBackground = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(6, 17, 33, 0.6);
  backdrop-filter: blur(16px);

  height: 100%;
  flex-direction: column;
  justify-content: center;
`

type ModalProps = {
  zIndex?: number
  onClose?: () => void
} & BoxProps

export const Modal = ({ onClose, zIndex = 99, ...restProps }: ModalProps) => {
  // TODO should check why works on desktop size, but not on mobile
  useEffect(() => {
    document.body.style.overflowY = 'hidden'

    return () => {
      document.body.style.overflowY = 'unset'
    }
  }, [])

  return (
    <>
      <ModalBackground zIndex={zIndex} onClick={onClose}></ModalBackground>
      <Portal>
        <Box
          zIndex={zIndex + 1}
          borderRadius="8px"
          mx="auto"
          backgroundColor="primaryPaleWhite"
          position="fixed"
          left="50%"
          top="50%"
          customCss={{
            transform: 'translate(-50%, -50%)',
          }}
          {...restProps}
        >
          {restProps.children}
        </Box>
      </Portal>
    </>
  )
}
